<template> 
<div>
    <navbar/>
	<div class="row justify-content-center">            
        <div class="col-lg-10 col-md-10">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                    <router-link to="/casos/crear" class="linkRefnum">Crear</router-link>
                     <div  class="col-md-12 ">
                        buscador páginado: {{tipoBuscador}}
                        <input class="form-control" v-model="filtroBuscar" @keyup="buscador"/>
                    </div>
                    <vue-good-table :columns="columns" :rows="allCasos" :key="reload" :search-options="searchOptions" :pagination-options="paginationOptions" :sort-options="sortOptions" styleClass="vgt-table striped ">
                        <template slot="table-actions">
                            <base-button type="white" size="sm" icon="fas fa-sync-alt" @click="getAll(true)"></base-button>
                        </template>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'refnum'" class="d-flex">
                                <router-link :to="getViewLink(props.row.id)" class="linkRefnum">{{ props.row.refnum }}</router-link>
                            </span>                            
                            <span v-else>
                              {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                    </vue-good-table>            
                </div>
            </div>
        </div>
    </div>
    <pre>{{data}}</pre>
</div>
	
</template>

<style lang="scss">
    @import '~vue-good-table/dist/vue-good-table.css';

    .vgt-global-search {
        border: 0 !important;
        background: none !important;

        .vgt-global-search__input {
            @apply p-0;

            .input__icon {
                position: absolute;
                top: 0;
                right: 15px;
                max-width: 32px;
                left: inherit;
            }

            .vgt-pull-left {
                float: right !important;
            }

            .vgt-input {
                width: 50%;
                background-color: #fff;
                border: 0;
                border-bottom: 1px solid #eaeaea!important;
                border-radius: 0;
                -webkit-box-shadow: none;
                box-shadow: none;
                color: #565656;
                height: 30px;
                max-width: 100%;
                padding: 7px 40px 7px 10px;
                -webkit-transition: all 300ms linear 0s;
                transition: all 300ms linear 0s;

                &:focus {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    border-color: #b7b7b7;
                }

                @screen sm {
                    width: 70%;
                }
                @screen lg {
                    width: 40%;
                }
            }
        }
    }

    .vgt-table {
        border: 0 !important;
        font-size: 14px !important;

        &.striped tbody tr:nth-of-type(odd) {
            @apply bg-grey-lightest;
        }

        thead th {
            @apply border-b bg-grey-light;
            background: none !important;
        }

        tbody td {
            vertical-align: middle !important;
            border-bottom: 0 !important;
        }
    }

    .vgt-wrap__actions-footer {
        @apply border-0 border-b bg-grey-light;
    }

    .vgt-wrap__footer {
        border: 0 !important;
        background: none !important;
    }

    .linkRefnum {
        text-decoration: underline!important;
        cursor: pointer!important;
    }

    .linkRefnum:hover {
        opacity: .6;
    }
</style>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import { VueGoodTable } from 'vue-good-table'
    import gql from 'graphql-tag';
    import { Agente_auth } from 'portalba360'
    // export let GET_MY_TODOS = gql`
    // query {
    //     casos {
    //         id
    //         asunto,
    //         idcontactodesc
    //         contacto{
    //             nombre,
    //             apellido
    //         }
    //     }
    // }`;

	export default {
        components: {
            VueGoodTable,
            navbar: () => import('@/views/Agente/navBar.vue')
        },
        // apollo: {
        //     casos: GET_MY_TODOS,
        // },
        data() {
          return {
                valuePagination: {
                    default: 1
                },
                columns: [{
                        label: 'N°',
                        field: 'refnum',
                        thClass: 'centrarColumn',
                        width: '100px',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Asunto',
                        field: 'asunto',
                        thClass: 'centrarColumn'
                    }, {
                        label: 'Fecha',
                        field: 'fechacreacion',
                        dateInputFormat: 'YYYY-MM-DD',
                        dateOutputFormat: 'DD-MM-YYYY',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Tipo',
                        field: 'idtipodesc',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Estado',
                        field: 'idestadodesc',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Canal',
                        field: 'origen',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Reabrir',
                        field: 'actions',
                        sortable: false,
                        thClass: 'centrarColumn',
                        width: '90px',
                        tdClass: 'vgt-center-align'
                    }
                ],
                sortOptions: {
                    enabled: true,
                    initialSortBy: { field: 'refnum', type: 'desc'}
                },
                searchOptions: {
                    enabled: true,
                    placeholder: 'Buscar'
                },
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPage: 10,
                    position: 'bottom',
                    perPageDropdown: [10, 25, 50, 100],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'Siguiente',
                    prevLabel: 'Anterior',
                    rowsPerPageLabel: 'Registros por pág.',
                    ofLabel: 'de',
                    pageLabel: 'pág.',
                    allLabel: 'Todos'
                },
                filtroBuscar: '',
                reload: 0,
                tipoBuscador: ''
             
             
          }
        },
  
        computed: {
            ...mapGetters('validatetoken', { allCasos: 'all', userLogin: 'userLogin' }),
            pagination() {
                return { pagina: 1, cantidad: 10 }
            },
            data(){
                const user = new Agente_auth()
                return user.one('usuario')
            }
        },        
        methods: {
            ...mapActions('validatetoken', { getCasos: 'getCasos', getAsignadoGrupo: 'getAsignadoGrupo', getParametrosSystem: 'getParametrosSystem', getParametrosCustom: 'getParametrosCustom' }),
            getAll(){
                this.getCasos({
                    ...this.pagination
                })
                this.getParametrosSystem({
                    parametro: 1
                })
                this.getParametrosCustom({
                    parametro: 1
                })
            },
            getViewLink(id){
                 return {
                    name:  'casos.editar',
                    params: { id } 
                }
            },
            buscador(){
                console.log(this.filtroBuscar);
                if (this.filtroBuscar.length > 2) {
                    // filtrobuscar:  this.filtroBuscar !== '' ? this.filtroBuscar : '' 
                let data = {}
                data = {
                    pagina: 1,
                    cantidad: 10,
                    filtrobuscar:  this.filtroBuscar !== '' ? this.filtroBuscar : '' 
                }
                this.getCasos(data)
                    this.getCasos(data).then(()=>{
                        this.reload++
                    })
                }
            }
        },
        mounted() {
            this.getAll()
        },
    }
</script>